import AuthenticatedLayout from '@/layouts/AuthenticatedLayout'
import AssessmentPage from '@/pages/Assessment'
import Dashboard from '@/pages/Dashboard'
import Investigations from '@/pages/Investigations'
import InvestigationDetails from '@/pages/InvestigationDetails'
import Transactions from '@/pages/Transactions'
import Earnings from '@/pages/Earnings'
import Withdrawals from '@/pages/Withdrawals'
import Settings from '@/pages/Settings'
import Users from '@/pages/Users'
import WaitList from '@/pages/Waitlist'
import Support from '@/pages/Support'
import EmployeeConsent from '@/pages/EmployeeConsent'
import Login from '@/pages/Auth/Login'
import SignUp from '@/pages/Auth/SignUp'
import VerifyAccount from '@/pages/Auth/VerifyAccount'
import AccountCreated from '@/pages/Auth/AccountCreated'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { createBrowserRouter, Outlet } from 'react-router'

// Placeholder components for missing pages
function ErrorPage() {
  return (
    <div className='flex items-center justify-center min-h-screen'>
      <div className='text-center'>
        <h1 className='text-4xl font-bold text-gray-900 mb-4'>404</h1>
        <p className='text-gray-600'>Page not found</p>
      </div>
    </div>
  )
}

function PublicLayout() {
  return <Outlet />
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <PublicLayout />,
    children: [
      {
        index: true,
        element: <WaitList />,
      },
      {
        path: 'login',
        element: (
          <ErrorBoundary fallback={<Login />}>
            <Login />
          </ErrorBoundary>
        ),
      },
      {
        path: 'signup',
        element: <SignUp />,
      },
      {
        path: 'verify-account',
        element: <VerifyAccount />,
      },
      {
        path: 'account-created',
        element: <AccountCreated />,
      },
      {
        path: 'employee-consent/:linkToken',
        element: <EmployeeConsent />,
      },
      {
        path: 'about',
        element: (
          <div className='p-8'>
            <h1 className='text-3xl font-bold'>About Page</h1>
          </div>
        ),
      },
      {
        element: <AuthenticatedLayout />,
        children: [
          {
            path: 'dashboard',
            element: <Dashboard />,
          },
          {
            path: 'investigations',
            element: <Investigations />,
          },
          {
            path: 'investigations/:id',
            element: <InvestigationDetails />,
          },
          {
            path: 'transactions',
            element: <Transactions />,
          },
          {
            path: 'earnings',
            element: <Earnings />,
          },
          {
            path: 'withdrawals',
            element: <Withdrawals />,
          },
          {
            path: 'users',
            element: <Users />,
          },
          {
            path: 'assessment',
            element: <AssessmentPage />,
          },
          {
            path: 'results',
            element: (
              <div className='p-8'>
                <h1 className='text-3xl font-bold'>Results Page</h1>
                <p className='text-gray-600 mt-4'>Results page coming soon...</p>
              </div>
            ),
          },
          {
            path: 'learning-path',
            element: (
              <div className='p-8'>
                <h1 className='text-3xl font-bold'>Learning Path</h1>
                <p className='text-gray-600 mt-4'>
                  Learning path page coming soon...
                </p>
              </div>
            ),
          },
          {
            path: 'settings',
            element: <Settings />,
          },
          {
            path: 'support',
            element: <Support />,
          },
        ],
      },
      {
        path: '*',
        element: <ErrorPage />,
      },
    ],
  },
])

export default router
